import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";

//Redux
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logoutUserAction } from "../../../redux/actions";
import { AuthRoles } from "../../../Common/global";
import { artist_logout } from "../../../Common/data";

export default function LogoutMenu({ children, ...props }) {
  //Styles
  const styles = {
    wrapper: {
      width: "1%",
      "&focus": {
        outline: "none",
      },
      fontFamily: `${props.artist ? "titleFont" : "inherit"}`,
      fontWeight: "300",
    },
    text: {
      fontFamily: "titleFont",
      fontSize: ".85em",
    },
  };
  //Local State
  const [open, setOpen] = useState(false);
  const anchorRef = useRef();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const dispatch = useDispatch(); //to update our redux state
  const currentState = useSelector((state) => state.TederReducerState);

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    artist_logout(currentState.userContext.userID);
    const tederLogoutDetails = {
      userID: "",
      userFirstName: "",
      userLastName: "",
      userEmail: "",
      pendingShows: 0,
      userLoggedIn: false,
      userType: AuthRoles.ANONYMOUS,
    };
    handleClose();
    dispatch({ type: "CLEAR_DATA" });
    dispatch(logoutUserAction(tederLogoutDetails));
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          style={styles.wrapper}
          focus="true"
          onClick={handleToggle}
        >
          {children}
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem sx={styles.text} onClick={handleLogout}>
                      Log Out
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
